import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {BehaviorSubject, forkJoin, from, Observable, of, ReplaySubject, zip} from 'rxjs';
import {catchError, concatAll, concatMap, map, mergeMap, toArray} from 'rxjs/operators';
import {localesDictionary} from 'src/app/configs/languages.dictionary';
import {TenantMailFooter} from 'src/app/core/models/tenant-management/tenant-mail-footer.model';
import {WebServiceHelperService} from 'src/app/shared/web-service-helper.service';
import {environment} from 'src/environments/environment';
import {UserMenuService} from '../../content/user-menu.service';

//import { firstValueFrom } from 'rxjs/';


@Injectable({
    providedIn: 'root'
})
export class TenantMailFooterService {

    public footer$: ReplaySubject<Array<TenantMailFooter>>;

    public currentFooterTpl: BehaviorSubject<string>;
    public currentFooterTpl$: Observable<string>;

    constructor(
        private http: WebServiceHelperService,
        private translator: TranslateService,
        private user: UserMenuService
    ) {
        this.footer$ = new ReplaySubject(1);

        this.currentFooterTpl = new BehaviorSubject(null);
        this.currentFooterTpl$ = this.currentFooterTpl.asObservable();


        this.getFooterTplByCurrentLang()

        this.http.get<Array<TenantMailFooter>>(`${environment.backEndDomain}api/mail_tpl`)
            .pipe(
                map(res => {
                    const langs = this.translator.getLangs().sort((a, b) => a == this.translator.currentLang ? 1 : -1);

                    return langs.map(lang => {
                        const tpl = res.find(t => t.lang === lang);

                        if (tpl) {
                            return tpl;
                        }

                        return {
                            lang,
                            tpl: ''
                        } as TenantMailFooter;
                    });
                }),
                map(tpls => tpls.reverse())
            ).subscribe(res => {
            console.log(res);
            this.footer$.next(res)
        }, err => console.error(err));
    }

    public setMailFooter(data: Array<TenantMailFooter>): Observable<any> {

        const langs = this.translator.getLangs();

        const PopulatedTpls = data.filter(tpl => tpl.tpl != '');
        const TplsToDelete = data.filter(tpl => tpl.tpl == '');

        const request = [];

        request.push(this.http.post(`${environment.backEndDomain}api/mail_tpl`, PopulatedTpls))

        TplsToDelete.forEach(tpl => {
            request.push(this.http.delete(`${environment.backEndDomain}api/mail_tpl/${tpl.lang}`, {}));
        })

        return zip(... request);

    }


    private buildTplForLocale(locale: string): string {
        try {

            const thanksText = this.translator.instant('Thanks a lot');
            const ifHelpText = this.translator.instant('if you need more help, you can contact us using this email');
            const greetings = this.translator.instant('greetings');
            const theTeamText = this.translator.instant('MyRubric team');

            return `${thanksText}\n\n${ifHelpText}: support@myrubric.com\n\n${greetings}\n${theTeamText}`;

        } catch (e) {
            throw {locale, e}
        }
    }

    public getFooterTplByCurrentLang(): void {
        const currentLang = this.translator.getDefaultLang();
        /** añadele el currentLanguage en el request */

        this.http.get<{ tpl: string }>(`${environment.backEndDomain}api/mail_tpl/${currentLang}`)
            .subscribe(res => this.currentFooterTpl.next(this.parseToHtml(res.tpl)), err => console.error(err));
    }


    private parseToHtml(tpl: string): string {
        const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;

        return tpl
            .split('\n')
            .map(linea => {
                if (linea.trim() === '') {
                    return '<div>&nbsp;</div>'; // Mantiene líneas vacías
                }

                const lineaConLink = linea.replace(emailRegex, (email) => {
                    return `<a href="mailto:${email}">${email}</a>`;
                });

                return `<div>${lineaConLink}</div>`;
            })
            .join('');
    }

}
